import { gql } from '@apollo/client';
export const FIELD_FIELDS = gql `
  fragment FieldFields on Field {
    id
    createdAt
    updatedAt
    clientId
    entityType
    name
    code
    type
    isRequired
    isActive
    isSystem
    selections
    isLookup
    sortOrder
    validations {
      isUnique
      minLength
      maxLength
      minRange
      maxRange
      minDate
      maxDate
      matchRegex
      notMatchRegex
      valueFormat
      dataType
      greaterThanField
      lessThanField
      requiredIfFieldExists
      requiredIfFieldNotExists
      requiredGroupName
    }
  }
`;
export const FIELDS = gql `
  ${FIELD_FIELDS}
  query FIELDS($spec: FieldSpec!) {
    fields(spec: $spec) {
      ...FieldFields
    }
  }
`;
export const SAVE_FIELD = gql `
  ${FIELD_FIELDS}
  mutation SAVE_FIELD($input: FieldInput!) {
    saveField(input: $input) {
      ...FieldFields
    }
  }
`;
export const DELETE_FIELD = gql `
  ${FIELD_FIELDS}
  mutation DELETE_FIELD($id: Int!) {
    deleteField(id: $id) {
      ...FieldFields
    }
  }
`;
